"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const tslib_1 = require("tslib");
const index_1 = require("../../index");
const Integration_1 = require("../../entities/integrations/Integration");
const type_graphql_1 = require("type-graphql");
const typeorm_1 = require("typeorm");
const OsmosysBaseEntity_1 = require("../OsmosysBaseEntity");
const ContentSystem_1 = require("../content/ContentSystem");
let OsmosysMessage = class OsmosysMessage extends OsmosysBaseEntity_1.OsmosysBaseEntity {
    constructor(payload) {
        super();
        this.payload = payload;
    }
};
tslib_1.__decorate([
    type_graphql_1.Field(() => index_1.GraphQLJSON, {
        nullable: true,
    }),
    typeorm_1.Column({
        nullable: true,
        type: 'jsonb',
    }),
    tslib_1.__metadata("design:type", Object)
], OsmosysMessage.prototype, "payload", void 0);
tslib_1.__decorate([
    type_graphql_1.Field({
        nullable: true,
    }),
    typeorm_1.Column({
        nullable: true,
    }),
    tslib_1.__metadata("design:type", String)
], OsmosysMessage.prototype, "message", void 0);
tslib_1.__decorate([
    type_graphql_1.Field({
        nullable: true,
    }),
    typeorm_1.Column({
        nullable: true,
        type: 'character varying',
    }),
    tslib_1.__metadata("design:type", String)
], OsmosysMessage.prototype, "action", void 0);
tslib_1.__decorate([
    type_graphql_1.Field(() => String, {
        nullable: true,
    }),
    typeorm_1.Column({
        nullable: true,
        type: 'character varying',
    }),
    tslib_1.__metadata("design:type", Object)
], OsmosysMessage.prototype, "subTopic", void 0);
tslib_1.__decorate([
    type_graphql_1.Field(() => index_1.User, {
        nullable: true,
    }),
    typeorm_1.ManyToOne(() => index_1.User, {
        nullable: true,
        onDelete: 'SET NULL',
    }),
    tslib_1.__metadata("design:type", Object)
], OsmosysMessage.prototype, "sourceUser", void 0);
tslib_1.__decorate([
    type_graphql_1.Field(() => index_1.User, {
        nullable: true,
    }),
    typeorm_1.ManyToOne(() => index_1.User, {
        nullable: true,
        onDelete: 'SET NULL',
    }),
    tslib_1.__metadata("design:type", Object)
], OsmosysMessage.prototype, "targetUser", void 0);
tslib_1.__decorate([
    type_graphql_1.Field(() => index_1.User, {
        nullable: true,
    }),
    typeorm_1.ManyToOne(() => index_1.User, {
        nullable: true,
        onDelete: 'SET NULL',
    }),
    tslib_1.__metadata("design:type", Object)
], OsmosysMessage.prototype, "creatingUser", void 0);
tslib_1.__decorate([
    type_graphql_1.Field(() => index_1.Workspace, {
        nullable: true,
    }),
    typeorm_1.ManyToOne(() => index_1.Workspace, {
        nullable: true,
        onDelete: 'SET NULL',
    }),
    tslib_1.__metadata("design:type", Object)
], OsmosysMessage.prototype, "workspace", void 0);
tslib_1.__decorate([
    type_graphql_1.Field(() => index_1.Workspace, {
        nullable: true,
    }),
    typeorm_1.ManyToOne(() => index_1.Workspace, {
        nullable: true,
        onDelete: 'SET NULL',
    }),
    tslib_1.__metadata("design:type", Object)
], OsmosysMessage.prototype, "targetWorkspace", void 0);
tslib_1.__decorate([
    type_graphql_1.Field(() => index_1.Ad, {
        nullable: true,
    }),
    typeorm_1.ManyToOne(() => index_1.Ad, {
        nullable: true,
        onDelete: 'SET NULL',
    }),
    tslib_1.__metadata("design:type", Object)
], OsmosysMessage.prototype, "ad", void 0);
tslib_1.__decorate([
    type_graphql_1.Field(() => index_1.AccessKey, {
        nullable: true,
    }),
    typeorm_1.ManyToOne(() => index_1.AccessKey, {
        nullable: true,
        onDelete: 'SET NULL',
    }),
    tslib_1.__metadata("design:type", Object)
], OsmosysMessage.prototype, "accessKey", void 0);
tslib_1.__decorate([
    type_graphql_1.Field(() => index_1.Context, {
        nullable: true,
    }),
    typeorm_1.ManyToOne(() => index_1.Context, {
        nullable: true,
        onDelete: 'SET NULL',
    }),
    tslib_1.__metadata("design:type", Object)
], OsmosysMessage.prototype, "context", void 0);
tslib_1.__decorate([
    type_graphql_1.Field(() => index_1.EmailCampaign, {
        nullable: true,
    }),
    typeorm_1.ManyToOne(() => index_1.EmailCampaign, {
        nullable: true,
        onDelete: 'SET NULL',
    }),
    tslib_1.__metadata("design:type", Object)
], OsmosysMessage.prototype, "emailCampaign", void 0);
tslib_1.__decorate([
    type_graphql_1.Field(() => index_1.EmailList, {
        nullable: true,
    }),
    typeorm_1.ManyToOne(() => index_1.EmailList, {
        nullable: true,
        onDelete: 'SET NULL',
    }),
    tslib_1.__metadata("design:type", Object)
], OsmosysMessage.prototype, "emailList", void 0);
tslib_1.__decorate([
    type_graphql_1.Field(() => index_1.Email, {
        nullable: true,
    }),
    typeorm_1.ManyToOne(() => index_1.Email, {
        nullable: true,
        onDelete: 'SET NULL',
    }),
    tslib_1.__metadata("design:type", Object)
], OsmosysMessage.prototype, "email", void 0);
tslib_1.__decorate([
    type_graphql_1.Field(() => index_1.EmailTemplate, {
        nullable: true,
    }),
    typeorm_1.ManyToOne(() => index_1.EmailTemplate, {
        nullable: true,
        onDelete: 'SET NULL',
    }),
    tslib_1.__metadata("design:type", Object)
], OsmosysMessage.prototype, "emailTemplate", void 0);
tslib_1.__decorate([
    type_graphql_1.Field(() => index_1.EmailTemplateVersion, {
        nullable: true,
    }),
    typeorm_1.ManyToOne(() => index_1.EmailTemplateVersion, {
        nullable: true,
        onDelete: 'SET NULL',
    }),
    tslib_1.__metadata("design:type", Object)
], OsmosysMessage.prototype, "emailTemplateVersion", void 0);
tslib_1.__decorate([
    type_graphql_1.Field(() => index_1.HostedFile, {
        nullable: true,
    }),
    typeorm_1.ManyToOne(() => index_1.HostedFile, {
        nullable: true,
        onDelete: 'SET NULL',
    }),
    tslib_1.__metadata("design:type", Object)
], OsmosysMessage.prototype, "hostedFile", void 0);
tslib_1.__decorate([
    type_graphql_1.Field(() => index_1.Workflow, {
        nullable: true,
    }),
    typeorm_1.ManyToOne(() => index_1.Workflow, {
        nullable: true,
        onDelete: 'SET NULL',
    }),
    tslib_1.__metadata("design:type", Object)
], OsmosysMessage.prototype, "workflow", void 0);
tslib_1.__decorate([
    type_graphql_1.Field(() => index_1.WorkflowRun, {
        nullable: true,
    }),
    typeorm_1.ManyToOne(() => index_1.WorkflowRun, {
        nullable: true,
        onDelete: 'SET NULL',
    }),
    tslib_1.__metadata("design:type", Object)
], OsmosysMessage.prototype, "workflowRun", void 0);
tslib_1.__decorate([
    type_graphql_1.Field(() => index_1.WorkspaceMembership, {
        nullable: true,
    }),
    typeorm_1.ManyToOne(() => index_1.WorkspaceMembership, {
        nullable: true,
        onDelete: 'SET NULL',
    }),
    tslib_1.__metadata("design:type", Object)
], OsmosysMessage.prototype, "workspaceMembership", void 0);
tslib_1.__decorate([
    type_graphql_1.Field(() => ContentSystem_1.ContentSystem, {
        nullable: true,
    }),
    typeorm_1.ManyToOne(() => ContentSystem_1.ContentSystem, {
        nullable: true,
        onDelete: 'SET NULL',
    }),
    tslib_1.__metadata("design:type", Object)
], OsmosysMessage.prototype, "contentSystem", void 0);
tslib_1.__decorate([
    type_graphql_1.Field(() => Integration_1.Integration, {
        nullable: true,
    }),
    typeorm_1.ManyToOne(() => Integration_1.Integration, {
        nullable: true,
        onDelete: 'SET NULL',
    }),
    tslib_1.__metadata("design:type", Object)
], OsmosysMessage.prototype, "emailServiceProvider", void 0);
OsmosysMessage = tslib_1.__decorate([
    type_graphql_1.ObjectType(),
    typeorm_1.Entity(),
    tslib_1.__metadata("design:paramtypes", [Object])
], OsmosysMessage);
exports.OsmosysMessage = OsmosysMessage;
//# sourceMappingURL=OsmosysMessage.js.map